import PocketBase from 'pocketbase';

import { IShopItem } from '../types';

import { pocketbaseUrl } from '.';

const pocketbase = new PocketBase(pocketbaseUrl);

export const getShopList = async (collection: string, sortParam = '-city') => {
  const result = await pocketbase.collection(collection).getFullList({
    sort: sortParam,
    $autoCancel: false,
  });

  return result as IShopItem[];
};

export const getShopsByCity = async (collection: string, city: string) => {
  const { items } = await pocketbase.collection(collection).getList(1, 50, {
    filter: pocketbase.filter(`city = {:city}`, { city }),
  });

  return items as IShopItem[];
};
